import { SYMBOL_FONTS } from '@/constants';
import { isWarningMaterial, isProhibitionMaterial, isMandatoryMaterial, isGHSMaterial } from '@/helpers';

export default () => {
  if (isWarningMaterial()) {
    return SYMBOL_FONTS.WARNING;
  } else if (isProhibitionMaterial()) {
    return SYMBOL_FONTS.PROHIBITION;
  } else if (isMandatoryMaterial()) {
    return SYMBOL_FONTS.MANDATORY;
  } else if (isGHSMaterial()) {
    return SYMBOL_FONTS.GHS;
  }

  return SYMBOL_FONTS.ADDITIONAL;
};
